import axios from 'axios'
import { BUSCAR_CIDADES } from '../types'
import { URL } from '../../util/ambienteActions';

export default function buscarCidadesPorNome (nome) {
    const url = `${URL}/public/cidades/nome/${nome.replace(/[.*+?^${};%()|[\]\\]/g, '')}`;
  return dispatch => axios.get(url).then(
      response => dispatch({
          type: BUSCAR_CIDADES,
        payload: response

      })
  );
}
